var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.data.configuration.wb_html_code__long_text__)}})}
var staticRenderFns = []

export { render, staticRenderFns }